import React from "react";
import { Button, Spinner } from "react-bootstrap";
import styles from "./style.module.css";

const LoadMoreButton = ({ onClick, loading }) => {
  return (
    <div className={styles["loadMoreContainer"]}>
      {loading ? (
        <Spinner animation="border" variant="primary" />
      ) : (
        <Button
          variant="primary"
          onClick={onClick}
          disabled={loading}
          className={styles["loadMoreButton"]}
        >
          Daha Çox
        </Button>
      )}
    </div>
  );
};

export default LoadMoreButton;
